(() => {
  const desktopMenu = window.matchMedia('(min-width: 1200px) and (hover: hover) and (pointer: fine)');
  const closeDelay = 110;

  const setExpanded = (details, expanded) => {
    const summary = details.querySelector(':scope > summary');
    if (!summary) return;
    details.open = expanded;
    summary.setAttribute('aria-expanded', String(expanded));
  };

  const closeSiblingMenus = (details) => {
    const menu = details.closest('.header__inline-menu');
    if (!menu) return;
    menu.querySelectorAll(':scope > .list-menu > li > header-menu > details[open]').forEach((candidate) => {
      if (candidate !== details) setExpanded(candidate, false);
    });
  };

  const enhanceMenu = (details) => {
    if (details.dataset.tfcHoverMenu === 'true') return;
    details.dataset.tfcHoverMenu = 'true';
    let closeTimer;

    const open = () => {
      if (!desktopMenu.matches) return;
      window.clearTimeout(closeTimer);
      closeSiblingMenus(details);
      setExpanded(details, true);
    };

    const close = () => {
      if (!desktopMenu.matches) return;
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if (!details.matches(':hover') && !details.contains(document.activeElement)) setExpanded(details, false);
      }, closeDelay);
    };

    details.addEventListener('pointerenter', open);
    details.addEventListener('pointerleave', close);
    details.addEventListener('focusin', open);
    details.addEventListener('focusout', close);
  };

  const enhanceDesktopMenus = () => {
    document.querySelectorAll('.header__inline-menu header-menu > details').forEach(enhanceMenu);
  };

  const resetMenus = () => {
    if (desktopMenu.matches) return;
    document.querySelectorAll('.header__inline-menu header-menu > details[open]').forEach((details) => setExpanded(details, false));
  };

  const initialize = () => {
    enhanceDesktopMenus();
    resetMenus();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  desktopMenu.addEventListener('change', resetMenus);
  document.addEventListener('shopify:section:load', initialize);
})();
